<script setup>
import TabEstado from "./TabEstado.vue";
import HistorialDeMovimientos from "./HistorialDeMovimientos.vue";
import SelectorCuitLote from "./SelectorCuitLote.vue";
import { storeToRefs } from "pinia";
import SpinnerLoader from "@/components/Spinner/SpinnerLoader";

import {
  formatearInputMoneda,
  truncarTexto,
  truncarTextoTitulo,
} from "@/utils/helpers";

const props = defineProps({
  historialDeOfertasStore: Object,
});

const emit = defineEmits(["irASubasta"]);

const { selected_pujas: selectedPujas, selectAllCheck: selectAllCheck } =
  storeToRefs(props.historialDeOfertasStore);
</script>

<template>
  <div class="d-flex justify-content-end mb-2">
    <div class="form-check m-0">
      <input
        id="check-all"
        class="form-check-input"
        type="checkbox"
        v-model="selectAllCheck"
        @change="historialDeOfertasStore.toggleSelectAll()"
      />
      <label class="form-check-label ms-2" for="check-all">
        Seleccionar todo
      </label>
    </div>
  </div>
  <div
    v-for="puja in historialDeOfertasStore.selected_tab.listado"
    :key="puja.id"
    class="card mb-1"
  >
    <SpinnerLoader v-if="historialDeOfertasStore.cargandoHistorial" size="64px"/>
    <div class="card-body p-1 p-sm-2 pt-0 mt-3 mb-3">
      <div class="d-flex flex-row justify-content-between w-100 pt-1 ps-3">
        <h5 class="titulo_subasta_id text_black fw-bolder fs-15">
          ID {{ puja.subasta.external_id }}
        </h5>
        <div class="form-check">
          <input
            class="form-check-input checkbox_cuit"
            type="checkbox"
            v-if="historialDeOfertasStore.puedeMarcarCheckbox(puja)"
            v-model="selectedPujas"
            :value="puja"
          />
        </div>
      </div>

      <div
        class="d-flex flex-column ps-3"
        @click="emit('irASubasta', puja.lote.id)"
      >
        <h6 class="titulo_subasta_id text_black fw-bolder pb-0 mb-0">
          {{ truncarTextoTitulo(puja.subasta.titulo) }}
        </h6>
        <strong
          class="titulo_subasta_id codigo_lote text_black fw-bolder pb-0 mb-0"
        >
          {{ truncarTexto(puja.lote.titulo) }}
        </strong>
      </div>

      <div class="d-flex flex-column w-100 m-0 mt-2 ps-1">
        <div class="row justify-content-between pb-2 m-0">
          <div class="col-6 fw-bold text-soft-grey-74 fs-12">
            Oferta vigente
          </div>
          <div class="col-6 text-end text-black fw-700">
            $ {{ formatearInputMoneda(puja.oferta_actual) }}
          </div>
        </div>

        <div class="row justify-content-between pb-2 m-0">
          <div class="col-6 fw-bold text-soft-grey-74 fs-12">
            CUIT para facturación
          </div>
          <div class="col-6 d-flex align-items-center justify-content-end">
            <SelectorCuitLote
              v-if="historialDeOfertasStore.puedeElegirCuit(puja)"
              :puja="puja"
              :historialDeOfertas="historialDeOfertasStore"
              class="ms-auto"
            />
          </div>
        </div>

        <div class="row justify-content-between pb-2 mt-2 m-0">
          <div class="col-6 fw-bold text-soft-grey-74 fs-12">
            Estado de Oferta
          </div>
          <div class="col-6 d-flex justify-content-end">
            <TabEstado
              class="align-self-end fs-10"
              :puja="puja"
              :user-id="historialDeOfertasStore.usuarioStore.user?.id"
            />
          </div>
        </div>

        <div class="row justify-content-between pb-2 m-0">
          <div class="col-6 fw-bold text-soft-grey-74 fs-12">
            Estado de Aprobación
          </div>
          <div class="col-6 d-flex justify-content-end">
            <div
              v-if="historialDeOfertasStore.puedeElegirCuit(puja)"
              class="d-flex flex-column align-items-end"
            >
              <span
                v-if="historialDeOfertasStore.textoAprobacion(puja)"
                class="badge badge-sm badge_aprobacion align-items-end"
              >
                <i class="fa-solid fa-tag"></i>
                {{ historialDeOfertasStore.textoAprobacion(puja) }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mt-2 ps-2 pe-2">
          <div class="col-9 d-flex align-items-center">
            <strong class="text_black fw-bolder pe-2"
              >Historial de Movimientos</strong
            >
            <i
              @click="historialDeOfertasStore.toggleMostrarMovimientos(puja.id)"
              :class="
                historialDeOfertasStore.mostrarMovimientos.includes(puja.id)
                  ? 'fa-solid fa-angle-down'
                  : 'fa-solid fa-angle-right'
              "
            />
          </div>

          <div class="col-3">
            <button
              v-if="puja.lote.estado_lote.slug === 'en-subasta'"
              class="btn btn-soft-green boton_oferta float-end"
              @click="emit('irASubasta', puja.lote.id)"
            >
              Ofertar
            </button>
          </div>

          <HistorialDeMovimientos
            v-if="historialDeOfertasStore.mostrarMovimientos.includes(puja.id)"
            :movimientos="puja.ofertas"
            :usuario_id="historialDeOfertasStore.usuarioStore.user?.id"
            :key="puja.id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.float_center {
  margin-left: auto;
  margin-right: auto;
}

.text_black {
  color: black !important;
}

.badge_aprobacion {
  background-color: #231f20 !important;
  align-items: center;
  color: #fff;
  gap: 8px;
  padding: 8px 12px;
  font-weight: 700;
}

.titulo_subasta {
  font-size: large;
}

.checkbox_cuit {
  min-width: 15px;
}

.boton_oferta {
  background-color: green !important;
  min-width: 60px !important;
  max-width: 70px !important;
  padding: 5px !important;
}

@media (max-width: 575px) {
  .badge_aprobacion {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
  }
}
</style>
